module.exports = __webpack_public_path__ + "2efa5dc512480ccade3c324cf1a93853.svg";